export const SET_ORDERS = 'SET_ORDERS';
export const REMOVE_ORDER = 'REMOVE_ORDER'
export const ADD_ORDER = 'ADD_ORDER'